
import type { ColorRepresentation } from 'three';

export interface MajakuTheme {
  name: 'dark' | 'day';
  background: ColorRepresentation;
  fog: {
    color: ColorRepresentation;
    density: number; // Exponential fog density
  };
  lighting: {
    ambientIntensity: number;
    ambientColor: ColorRepresentation;
    directionalIntensity: number;
    directionalColor: ColorRepresentation;
    directionalPosition: { x: number; y: number; z: number };
  };
  ribbons: {
    color: ColorRepresentation;
    opacity: number;
  };
  water: {
    color: ColorRepresentation;
    opacity: number;
  };
}

export const DARK_THEME: MajakuTheme = {
  name: 'dark',
  background: 0x000000,
  fog: {
    color: 0x000000,
    density: 0.002,
  },
  lighting: {
    ambientIntensity: 0.2,
    ambientColor: 0x404040,
    directionalIntensity: 0,
    directionalColor: 0x000000,
    directionalPosition: { x: 0, y: 10, z: 0 },
  },
  ribbons: {
    color: 0x00aaff, // Cyan/Blue
    opacity: 0.1,
  },
  water: {
    color: 0x000000,
    opacity: 0,
  }
};

export const DAY_THEME: MajakuTheme = {
  name: 'day',
  background: 0x87CEEB, // Sky Blue
  fog: {
    color: 0x87CEEB,
    density: 0.0015, // Slightly less dense than night
  },
  lighting: {
    ambientIntensity: 0.6,
    ambientColor: 0xffffff,
    directionalIntensity: 1.2,
    directionalColor: 0xffffee, // Warm sun
    directionalPosition: { x: 50, y: 100, z: 50 },
  },
  ribbons: {
    color: 0xffffff, // White/Silver
    opacity: 0.8,
  },
  water: {
    color: 0x87CEEB,
    opacity: 0.6,
  }
};

